interface LoadingStateProps {
  label?: string
  /** Skeleton table rows for list hubs */
  rows?: number
  columns?: number
  variant?: 'text' | 'skeleton-table' | 'skeleton-block'
}

export function LoadingState({
  label = 'Loading…',
  rows = 6,
  columns = 5,
  variant = 'text',
}: LoadingStateProps) {
  if (variant === 'skeleton-table') {
    return (
      <div className="table-pane table-pane--fill" aria-busy="true" aria-label={label}>
        <div className="table-pane__scroll">
          <table className="table table--dense">
            <thead>
              <tr>
                {Array.from({ length: columns }, (_, i) => (
                  <th key={i} scope="col">
                    <span className="skeleton skeleton--text" />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: rows }, (_, r) => (
                <tr key={r}>
                  {Array.from({ length: columns }, (_, c) => (
                    <td key={c}>
                      <span className="skeleton skeleton--text" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  if (variant === 'skeleton-block') {
    return (
      <div className="skeleton-block" aria-busy="true" aria-label={label}>
        <span className="skeleton skeleton--line" />
        <span className="skeleton skeleton--line" />
        <span className="skeleton skeleton--line skeleton--line-short" />
      </div>
    )
  }

  return (
    <p className="loading" role="status" aria-live="polite">
      {label}
    </p>
  )
}
